export const EMAIL_ERROR = 'Неправильный формат почты';